/**
 * Yallmark header: opens and closes the mobile menu drawer (<dialog>).
 * Triggers: [data-ym-drawer-open="<dialog id>"], close: [data-ym-drawer-close] inside the dialog.
 */
(function () {
  if (window.ymHeaderInit) return;
  window.ymHeaderInit = true;

  const desktop = window.matchMedia('(min-width: 1024px)');

  /** @param {HTMLDialogElement} dialog */
  function close(dialog) {
    if (!dialog.open) return;
    dialog.close();
  }

  document.addEventListener('click', function (event) {
    const target = /** @type {HTMLElement} */ (event.target);

    const opener = target.closest('[data-ym-drawer-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-ym-drawer-open') || '');
      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.showModal();
        opener.setAttribute('aria-expanded', 'true');
        dialog.addEventListener(
          'close',
          function () {
            opener.setAttribute('aria-expanded', 'false');
          },
          { once: true }
        );
      }
      return;
    }

    if (target.closest('[data-ym-drawer-close]')) {
      const dialog = target.closest('dialog');
      if (dialog) close(dialog);
      return;
    }

    // Click on the backdrop: the event target is the dialog itself.
    if (target instanceof HTMLDialogElement && target.classList.contains('ym-drawer')) {
      close(target);
    }
  });

  desktop.addEventListener('change', function (event) {
    if (!event.matches) return;
    document.querySelectorAll('dialog.ym-drawer[open]').forEach(function (dialog) {
      close(/** @type {HTMLDialogElement} */ (dialog));
    });
  });
})();
